/** Format newly entered names without overwriting intentional mixed-case spelling. */
export const formatPersonName = (value: string): string =>
  value.trim().replace(/\s+/g, ' ').replace(/[A-Za-zÀ-ÖØ-öø-ÿ]+/g, (word) => {
    const first = word.charAt(0).toLocaleUpperCase();
    const rest = word.slice(1);
    const hasMixedCase = word !== word.toLocaleLowerCase() && word !== word.toLocaleUpperCase();
    return first + (hasMixedCase ? rest : rest.toLocaleLowerCase());
  });

/** Join a final "bhai" to the preceding name, as commonly written in Gujarati names. */
export const joinBhaiSuffix = (value: string): string =>
  value.trim().replace(/\s+/g, ' ').replace(/\s+bhai$/i, 'bhai');

export const formatFrontDeskName = (value: string): string =>
  joinBhaiSuffix(formatPersonName(value));
